import { FormikComboBox } from '../../../../cdl/ComboBox/FormikComboBox';
import { sortCategory } from '../../../../common/helpers/sortByCategory.helper';
import { useEnums } from '../../../../common/hooks/useEnums';

import { ProductCategoryOption } from './ProductCategoryOption';

interface EnumType {
    enums: {
        vesselTankCategory: {
            [enumValue: string]: {
                humanReadableValue: string;
            };
        };
    };
}

interface FormikProductCategorySelectProps {
    name: string;
    label?: string;
    tankCategories?: string[];
    unavailableCategories?: string[];
}

export const FormikProductCategorySelect = ({
    name,
    label,
    tankCategories = [],
    unavailableCategories = [],
}: FormikProductCategorySelectProps) => {
    const { enums }: EnumType = useEnums();

    const categoryOptions = Object.keys(enums.vesselTankCategory)
        .sort((firstCategory, secondCategory) => {
            const tankOrder =
                Number(tankCategories.includes(secondCategory)) - Number(tankCategories.includes(firstCategory));
            return tankOrder || sortCategory(firstCategory, secondCategory);
        })
        .map((key) => {
            return {
                label: enums.vesselTankCategory[key].humanReadableValue,
                value: key,
                inTank: tankCategories.includes(key),
                disabled: unavailableCategories.includes(key),
            };
        });

    return (
        <FormikComboBox
            name={name}
            label={label}
            options={categoryOptions}
            OptionComponent={ProductCategoryOption}
            ValueComponent={ProductCategoryOption}
        />
    );
};
